"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxOptionMetaMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var ListboxOptionMetaMixin = (0, _styledToken.default)('ListboxOption.metaColor', function (color) {
  return (0, _styledComponents.css)(["color:", ";"], color);
});
exports.ListboxOptionMetaMixin = ListboxOptionMetaMixin;